import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../pages/Login.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../pages/Dashboard.vue'),
    redirect: '/projects',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'projects',
        name: 'ProjectList',
        component: () => import('../pages/ProjectList.vue'),
        meta: { title: '项目管理' },
      },
      {
        path: 'map',
        name: 'MapView',
        component: () => import('../pages/MapView.vue'),
        meta: { title: '地图总览' },
      },
      {
        path: 'projects/add',
        name: 'ProjectAdd',
        component: () => import('../pages/ProjectForm.vue'),
        meta: { title: '新增项目' },
      },
      {
        path: 'projects/edit/:id',
        name: 'ProjectEdit',
        component: () => import('../pages/ProjectForm.vue'),
        meta: { title: '编辑项目' },
      },
      {
        path: 'users',
        name: 'UserList',
        component: () => import('../pages/UserList.vue'),
        meta: { title: '用户管理' },
      },
      {
        path: 'logs',
        name: 'LogList',
        component: () => import('../pages/LogList.vue'),
        meta: { title: '操作日志' },
      },
      {
        path: 'banners',
        name: 'BannerList',
        component: () => import('../pages/BannerList.vue'),
        meta: { title: '轮播图管理' },
      },
      {
        path: 'subcategories',
        name: 'SubcategoryList',
        component: () => import('../pages/SubcategoryList.vue'),
        meta: { title: '二级细分项管理' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn;

  if (to.meta.requiresAuth !== false && !isLoggedIn) {
    next('/login');
  } else if (to.path === '/login' && isLoggedIn) {
    next('/projects');
  } else {
    next();
  }
})

export default router
